import { Box, Switch, Typography } from "@mui/material";

export default function SwitchRow({ title, description, name, value, onChange, disabled, align }) {
    return (
        <Box
            sx={(theme) => ({ padding: theme.spacing(1), cursor: "pointer" })}
            onClick={() => {
                !disabled && onChange?.({ target: { name, checked: !!!value, type: "checkbox" } });
            }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: align === "right" ? "space-between" : "flex-start",
                    alignItems: "center",
                    flexDirection: align === "right" ? "row-reverse" : "row",
                    gap: 2,
                }}>
                <Switch name={name} checked={!!value} disabled={disabled} />
                <div>
                    <Typography variant="h6" gutterBottom color={disabled ? "text.disabled" : "text.primary"}>
                        {title}
                    </Typography>
                    {description ? (
                        <Typography variant="caption" color={disabled ? "text.disabled" : "text.secondary"} component="div">
                            {description}
                        </Typography>
                    ) : null}
                </div>
            </Box>
        </Box>
    );
}
